import api from "../api";

class MarketingService {
	async findAllCampaigns() {
		return new Promise((res, reject) => {
			return api
				.get("/campaigns")
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async getCampaign(id) {
		return new Promise((res, reject) => {
			return api
				.get("/campaigns/" + id)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async updateCampaign(campaign) {
		return new Promise((res, reject) => {
			return api
				.put("/campaigns/" + campaign.id, campaign)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async createCampaign(campaign) {
		return new Promise((res, reject) => {
			return api
				.post("/campaigns", campaign)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async deleteCampaign(campaign) {
		return new Promise((res, reject) => {
			return api
				.delete("/campaigns/" + campaign.id)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async findAllCategories() {
		return new Promise((res, reject) => {
			return api
				.get("/campaigns/categories")
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async getCategory(id) {
		return new Promise((res, reject) => {
			return api
				.get("/campaigns/categories/" + id)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	// calls proc spMarketInsuranceMapping
	async getInsuranceFromMapping(params) {
		return new Promise((res, reject) => {
			return api
				.get("/marketingInsuranceMapping", params)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async updateCategory(category) {
		return new Promise((res, reject) => {
			return api
				.put("/campaigns/categories/" + category.id, category)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async createCategory(category) {
		return new Promise((res, reject) => {
			return api
				.post("/campaigns/categories", category)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async deleteCategory(category) {
		return new Promise((res, reject) => {
			return api
				.delete("/campaigns/categories/" + category.id)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async getActiveCampaigns() {
		return new Promise((res, reject) => {
			return this.findAllCampaigns().then((result) => {
				return res(
					result.content.filter(function (item) {
						return item.isActive;
					})
				);
			});
		});
	}
}

const marketingService = new MarketingService();

export default marketingService;
